//
// setup highlight and theme
//
import { getMonacoAsync } from '@/utils/monacoProvider';
export async function setupShiki(monaco) {
    // 创建一个可复用的语法高亮器
    Promise.all([
        import('@shikijs/monaco'),
        import('shiki/bundle/web'),
    ]).then(([{ shikiToMonaco }, { createHighlighter }]) => createHighlighter({
        themes: [
            'one-dark-pro',
            'one-light',
        ],
        langs: [
            'vue',
            'javascript',
            'typescript',
            'yaml',
            'json',
            'css',
            'scss',
        ],
    }).then((highlighter) => {
        // 首先注册你需要的语言的 IDs
        monaco.languages.register({ id: 'vue', extensions: ['.vue'] });
        monaco.languages.register({ id: 'typescript', extensions: ['.ts'] });
        monaco.languages.register({ id: 'javascript', extensions: ['.js'] });
        monaco.languages.register({ id: 'yaml', extensions: ['.yaml'] });
        monaco.languages.register({ id: 'json', extensions: ['.json'] });
        monaco.languages.register({ id: 'css', extensions: ['.css'] });
        monaco.languages.register({ id: 'scss', extensions: ['.scss'] });
        // 注册 Shiki 主题，并为 Monaco 提供语法高亮
        shikiToMonaco(highlighter, monaco);
        monaco.editor.setTheme('one-dark-pro');
    }));
}
export async function syncMonacoTheme() {
    const monaco = await getMonacoAsync();
    if (!monaco) {
        return;
    }
    await setupShiki(monaco).catch((err) => {
        console.log('[syncMonacoTheme fail]', err);
    });
}
